import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';
import { updateKeyword, useSendKeywordDataMutation } from 'store/keyword';

// Keywordを管理するためのカスタムフック
export function useKeyword(area: string) {
  const dispatch = useDispatch();
  const keywordState = useSelector((state: RootState) => state.keyword);

  const { keyword, isInitialize, progress, result } = keywordState;
  const [lastResult, setLastResult] = useState<boolean | null>(null);

  const [sendKeywordData, { isLoading: isSubmittingKeyword, error: submitKeywordError }] =
    useSendKeywordDataMutation();

  const updateKeywordState = (newKeyword: string) => {
    dispatch(updateKeyword(newKeyword));
  };

  const sendKeyword = async (keyword: string) => {
    try {
      const result = await sendKeywordData({ keyword, area }).unwrap();
      setLastResult(result.result);
    } catch (error) {
      console.error('Failed to send keyword: ', error);
    }
  };

  return {
    keyword,
    isInitialize,
    progress,
    isSubmittingKeyword,
    submitKeywordError,
    updateKeywordState,
    sendKeyword,
    result,
    lastResult,
  };
}
